import CurrentDispatchCard from './CurrentDispatchCard';
import DrHistoryCard from './DrHistoryCard';
import DRLatestDispatchCard from './DRLatestDispatchCard';
import PowerPriceCard from './PowerPriceCard';
import DRResourceCard from './DRResourceCard';
import EVStationCard from './EVStationCard';
import EVChargerCard from './EVChargerCard';
import WeatherCard from './WeatherCard';
import ChargingDemandCard from './ChargingDemandCard';
import OpmContractSummaryCard from './OpmContractSummaryCard';
import { CARD_TYPES } from '../config/dashboardConfig';

const CardRenderer = ({ cardType, card, dashboardData, isEditMode, onToggle }) => {
  // sizeW, sizeH를 colSpan, rowSpan으로 변환 (하위 호환성 유지)
  const cardProps = {
    colSpan: card.sizeW || card.colSpan || 1,
    rowSpan: card.sizeH || card.rowSpan || 1,
    dashboardData,
    isEditMode,
    enabled: card.enabled,
    onToggle,
  };

  switch (cardType) {
    case CARD_TYPES.CURRENT_DISPATCH:
      return <CurrentDispatchCard {...cardProps} />;
    case CARD_TYPES.DR_HISTORY:
      return <DrHistoryCard {...cardProps} />;
    case CARD_TYPES.DR_LATEST_DISPATCH:
      return <DRLatestDispatchCard {...cardProps} />;
    case CARD_TYPES.POWER_PRICE:
      return <PowerPriceCard {...cardProps} />;
    case CARD_TYPES.DR_RESOURCE:
      return <DRResourceCard {...cardProps} />;
    case CARD_TYPES.EV_STATION:
      return <EVStationCard {...cardProps} />;
    case CARD_TYPES.EV_CHARGER:
      return <EVChargerCard {...cardProps} />;
    case CARD_TYPES.WEATHER:
      return <WeatherCard {...cardProps} />;
    case CARD_TYPES.CHARGING_DEMAND:
      return <ChargingDemandCard {...cardProps} />;
    case CARD_TYPES.OPM_CONTRACT_SUMMARY:
      return <OpmContractSummaryCard {...cardProps} />;
    default:
      return null;
  }
};

export default CardRenderer;

